import { useState } from "react";
import { useDispatch } from "react-redux";
import { DateTime } from "luxon";
import { getLongDateFormat } from "../../utils/luxonHelpers";
import { addShift } from "../../stores/member/memberActions";
import Modal from "../Modal";
import i18n from "../../utils/i18n";
import ShiftsBatchForm from "./ShiftsBatchForm";

const AddBatchShiftsButton = () => {
  const [showModal, setShowModal] = useState(false);
  const [batchShifts, setBatchShifts] = useState([{}]);
  const dispatch = useDispatch();

  const handleClick = () => {
    setBatchShifts([{}]);
    setShowModal(true);
  };

  const hideModal = () => {
    setShowModal(false);
  };

  const handleSubmit = (shifts) => {
    shifts.forEach((shift) => {
      const newShift = {
        ...shift,
        members: [],
        preferred_members: [],
      };
      dispatch(addShift(newShift));
    });

    hideModal();
  };

  const addPicker = () => {
    const newBatchShifts = [...batchShifts];
    const nextShift = { ...newBatchShifts[newBatchShifts.length - 1] };

    const longDateFormat = getLongDateFormat();

    if (nextShift.start_date) {
      nextShift.start_date = DateTime.fromFormat(
        nextShift.start_date,
        longDateFormat
      )
        .plus({ days: 1 })
        .toFormat(longDateFormat);
    }

    if (nextShift.end_date) {
      nextShift.end_date = DateTime.fromFormat(
        nextShift.end_date,
        longDateFormat
      )
        .plus({ days: 1 })
        .toFormat(longDateFormat);
    }

    newBatchShifts.push(nextShift);
    setBatchShifts(newBatchShifts);
  };

  const removePicker = (index) => {
    const newBatchShifts = [...batchShifts];
    newBatchShifts.splice(index, 1);
    setBatchShifts(newBatchShifts);
  };

  const handleChange = (index, key, value) => {
    const newBatchShifts = [...batchShifts];
    newBatchShifts[index][key] = value;
    setBatchShifts(newBatchShifts);
  };

  return (
    <span>
      <button
        type="button"
        onClick={handleClick}
        className="btn btn-primary btn-xs add_shift_button"
      >
        {i18n.t("schedule.shifts.add_batch_shifts")}
      </button>
      <Modal
        show={showModal}
        onHide={hideModal}
        title={i18n.t("schedule.shifts.add_batch_shifts_header")}
      >
        <ShiftsBatchForm
          batch_shifts={batchShifts}
          onSubmitHandler={handleSubmit}
          addPicker={addPicker}
          removePicker={removePicker}
          handleChange={handleChange}
        />
      </Modal>
    </span>
  );
};

export default AddBatchShiftsButton;
